import React from "react";
import { ddadosRegistrarSolicitacao as DDados } from "../deca.ddados";
import autoBind from "react-autobind";
import BaseComponent, { connect } from "@common/components/base.component";
import decaActions from "../store/deca.actions";
import DecaRetificarSolicitacao from "./deca.retificarsolicitacao.form";

//Selectors
import atividadeSelectors from "../components/atividades/store/atividade.selectors";
import cnaeSelectors from "../components/cnae/store/cnae.selectors";
import solicitacaoSelectors from "../components/solicitacao/store/solicitacao.selectors";
import socioSelectors from "../components/socio/store/socio.selectors";
import historicoSelectors from "../components/historico/store/historico.selectors";
import documentoSelector from "../components/documentos/store/documento.selectors";
import camposDinamicosSelectors from "../components/camposDinamicos/store/camposDinamicos.selectors";
import dadosCadastraisSelector from "../components/dadosCadastrais/store/dadosCadastrais.selectors";

class Container extends BaseComponent {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
    this.props.decaActions.setReducerTypeDeca(1);
  }

  componentDidMount() {
    const { id } = this.props.routerManager.params;
    this.props.decaActions.loadComboGrupo();
    this.props.decaActions.getParametro();

    this.props.decaActions.getById({ id: id, prefix: "R" });
  }

  validateString(tipo) {
    return typeof tipo === "string";
  }

  onSubmit(values) {
    const {
      dadosCadastraisSelector,
      atividadeSelectors,
      historicoSelectors,
      cnaeSelectors,
      documentoSelector,
      socioSelectors,
      camposDinamicosSelectors,
      solicitacaoSelectors,
      routerManager,
    } = this.props;

    //MONTA LISTA DECAATIVIDADE
    values.DecaAtividadeDto = atividadeSelectors.atividade.atividades.map(
      (ativi) => ({
        Id: ativi.Id,
        IdAtividade: ativi.IdAtividade,
        Principal: ativi.Principal ? 1 : 0,
      })
    );

    //MONTA LISTA DECA SOCIO
    values.DecaSocioDto = socioSelectors.socio.listaSocio.map((socio) => ({
      Id: socio.Id,
      CpfCnpj: socio.CpfCnpj,
      Nome: socio.Nome,
      DataEntrada: socio.DataEntrada,
      Email: socio.Email,
      Telefone: socio.Telefone,
      principal: socio.Principal,
      RgIe: socio.RgIe,
      IdCcmSocio: socio.IdCcmSocio,
      EnderecoSocio: socio.EnderecoSocio,
    }));

    //MONTA LISTA DECA HISTORICO
    values.DecaHistoricoDto = historicoSelectors.historico.historicos;

    //MONTA LISTA DECA CNAE
    values.DecaCnaeDto = cnaeSelectors.cnae.cnaes.map((cna) => ({
      Id: cna.Id,
      IdCnae: cna.IdCnae,
      Principal: cna.Principal ? 1 : 0,
      IdDecaSolicitacao: cna.IdDecaSolicitacao,
    }));

    //MONTA LISTA DECA CARACTERISTICA
    values.DecaCaracteristicaDto = [];

    const { arrayCaracteristicas } = camposDinamicosSelectors.camposDinamicos;

    values.DecaCaracteristicaDto = arrayCaracteristicas;

    //MONTA LISTA ANEXOS
    //anexos
    const { anexo, anexoCustomizado } = documentoSelector.documento;

    let DecaAnexoDto = [];

    if (anexo) DecaAnexoDto = [...anexo];
    if (anexoCustomizado) DecaAnexoDto = [...DecaAnexoDto, ...anexoCustomizado];

    values.DecaAnexoDto = DecaAnexoDto;

    this.props.decaActions.update({
      //DADOS SOLICITACAO
      CpfCnpjSolicitacao: values.CpfCnpjSolicitacao,
      TipoSolicitacao: solicitacaoSelectors.solicitacao.TipoSolicitacaoNumero,
      CCMSolicitacao: values.CCM,
      SituacaoSolicitacao: values.SituacaoSolicitacao,
      DescricaoSolicitacao: values.DescricaoSolicitacao,

      //DADOS SOLICITANTE
      CpfCnpjSolicitante: values.CpfCnpjSolicitante,
      NomeSolicitante: values.NomeSolicitante,
      EmailSolicitante: values.EmailSolicitante,
      TelefoneSolicitante: values.TelefoneSolicitante,
      RgIeSolicitante: values.RgIeSolicitante,
      CelularSolicitante: values.CelularSolicitante,
      // END DADOS SOLICITANTE

      //ENDERECO SOLICITANTE
      DecaEnderecoSolicitante: {
        ...values.EnderecoSolicitante,
        IdDecaSolicitacao: values.Id,
      },

      //DADOS CADASTRAIS
      NomeEmpresa: values.NomeCadastral,
      NomeFantasiaEmpresa: values.NomeFantasiaCadastral,
      EmailEmpresa: values.EmailCadastral,
      TelefoneEmpresa: values.TelefoneCadastral,
      CelularEmpresa: values.CelularCadastral,
      DataNascimento: values.DataNascimentoCadastral,
      RgIeEmpresa: values.RgIeCadastral,
      DataAbertura: values.DataAberturaCadastral,
      DataOcorrencia: values.DataOcorrencia,
      IdContador: values.Contador ? values.Contador.Id : undefined,
      Contador: values.Contador ? values.Contador.Exibicao : undefined,
      EmailContador: values.EmailContadorCadastral,
      RegimeTributacao: values.RegimeTributacaoCadastral
        ? values.RegimeTributacaoCadastral
        : dadosCadastraisSelector.dadosCadastrais.RegimeTributacaoCadastral,
      DescricaoAtividade: values.DescricaoAtividade,
      IdGrupo: values.IdGrupo,
      //DADOS DINAMICOS

      //ENDERECO PRINCIPAL
      DecaEnderecoPrincipal: {
        ...values.EnderecoPrincipal,
        IdDecaSolicitacao: values.Id,
      },

      // ENDERECO COBRANCA
      DecaEnderecoCobranca: {
        ...values.EnderecoCobranca,
        IdDecaSolicitacao: values.Id,
      },

      // LISTA CNAE
      DecaCnaeDto: values.DecaCnaeDto,

      // LISTA HISTORICO
      DecaHistoricoDto: values.DecaHistoricoDto,

      // LISTA SOCIO
      DecaSocioDto: values.DecaSocioDto,

      // LISTA ATIVIDADE
      DecaAtividadeDto: values.DecaAtividadeDto,

      //LISTA CARACTERISTICA

      DecaSolicitacaoCaracteristicaDto: values.DecaCaracteristicaDto,

      //LISTA ANEXO

      DecaAnexoDto: values.DecaAnexoDto,

      //LISTA FILE ANEXO

      DecaFileAnexoDto: values.DecaFileAnexoDto,

      Id: routerManager.params.id,
      MotivoRetificacao: values.MotivoRetificacao,
    });
  }

  render() {
    return <DecaRetificarSolicitacao onSubmit={this.onSubmit} />;
  }
}

export default connect({
  actions: {
    decaActions,
  },
  selectors: {
    dadosCadastraisSelector,
    atividadeSelectors,
    cnaeSelectors,
    historicoSelectors,
    documentoSelector,
    camposDinamicosSelectors,
    solicitacaoSelectors,
    socioSelectors,
  },
})(Container);
